<template>
  <div>
    <article class="m-card-element m-card-element-design-5 m-card-primary">

      <div class="m-card-element-info-data">
        <h5
          v-if="element.descripcion.categoria !== undefined"
          key="categoryName"
        >
          {{ productoCategoriaNombre }}
        </h5>
        <h5
          v-else
          key="noCategoryName"
        >
          {{ $t('mFeedSectionContentCardDesing2.noCategoryName') }}
        </h5>

        <textarea
          :class="$v.element.descripcion.nombre.$error ? 'm-card-element-design-5-name a-input-danger' : 'm-card-element-design-5-name'"
          name="nombre"
          spellcheck="false"
          :value="element.descripcion.nombre"
          ref="nombre"
          @blur="changeElementNombre"
        >
        </textarea>

        <div class="m-card-element-design-5-assets-included">
          <div
            v-for="i in 4"
            :key="`img${i}`"
          >
            <a
              class="m-card-element-edition-image"
              href="#"
              @click.prevent="changeCardImage(`inputImagen-${i}`)"
            >
              <img
                v-if="tarjeta.metadata[`imagen${i}`]"
                :alt="element.descripcion.nombre"
                :id="`cardImg-${i}`"
                :ref="`imagen${i}`"
                :src="tarjeta.metadata[`imagen${i}`]"
              >
              <img
                v-else
                :alt="element.descripcion.nombre"
                :class="showMetadataValidationError &&
                  tarjeta.metadata[`imagen${i}`] === ''
                  ? 'm-card-element-edition-image-error'
                  : ''"
                :id="`cardImg-${i}`"
                :ref="`imagen${i}`"
                src="@/assets/img/ds5.png"
              >
            </a>
            <input
              v-show="false"
              :data-img-id="`cardImg-${i}`"
              :data-img-pos="`${i}`"
              name="imagen"
              :id="`inputImagen-${i}`"
              ref="file"
              type="file"
              value=""
              @change="previewCardImage"
            >
          </div>
        </div>
      </div>

      <div class="m-card-element-info-state">
        <div class="m-card-element-info-state-of-access">
          <h3
            v-if="element.activo"
            key="available"
          >
            {{ $t('mFeedSectionContentCardDesing2.available') }}
          </h3>
          <h3
            v-else
            key="notAvailable"
          >
            {{ $t('mFeedSectionContentCardDesing2.notAvailable') }}
          </h3>
          <h4
            v-if="element.visible"
            key="visible"
          >
            {{ $t('mFeedSectionContentCardDesing2.visible') }}
          </h4>
          <h4
            v-else
            key="hidden"
          >
            {{ $t('mFeedSectionContentCardDesing2.hidden') }}
          </h4>
        </div>
        <router-link
          class="m-card-element-info-state-of-price"
          :to="`/${$t('rPaths.product')}/${$route.params.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
        >
          {{ productoPrecio }}
        </router-link>
      </div>

    </article>

    <p v-if="isAProductRoute">
      <a
        class="font-weight-bold text-link-hover-products"
        @click.prevent="changeCardType"
      >
        <i class="far fa-window-maximize margin-right-xsmall"></i>
        {{ $t('mEditionProductCard.selectCardTypes') }}
      </a>
    </p>

    <ul>
      <li>
        <small
          v-if="$v.element.descripcion.nombre.$error"
          class="text-color-danger"
        >
          {{ messageErrorNombre }}
        </small>
        <small
          v-if="!isFileExtensionValid"
          class="text-color-danger"
        >
          {{ messageErrorFileExtension }}
        </small>
        <small
          v-if="!isFileSizeValid"
          class="text-color-danger"
        >
          {{ messageErrorFileSize }}
        </small>
        <small
          v-if="showMetadataValidationError && !isMetadataValid && emptyFiles"
          class="text-color-danger"
        >
          {{ messageErrorFileRequired }}
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign5.messages.extensions') }}</i>
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign5.messages.dimensions') }}</i>
        </small>
      </li>
      <li>
        <small class="font-weight-light">
          <i>{{ $t('mFeedSectionContentCardEditionDesign5.messages.nameLength') }}</i>
        </small>
      </li>
    </ul>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeFeedSectionContentCardEditionDesign5',

  props: {
    element: Object,
    esPago: Boolean,
    elementCategorias: Array,
    showMetadataValidationError: Boolean,
    videoUrlParsed: {
      type: [String, Boolean],
      default: false
    }
  },

  data () {
    return {
      isFileExtensionValid: true,
      isFileSizeValid: true,
      isMetadataValid: true,

      tarjeta: {
        tipo: 5,
        metadata: {
          imagen1: '',
          imagen2: '',
          imagen3: '',
          imagen4: ''
        }
      }
    }
  },

  validations: {
    element: {
      descripcion: {
        nombre: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    emptyFiles () {
      return this.tarjeta.metadata.imagen1 === '' ||
        this.tarjeta.metadata.imagen2 === '' ||
        this.tarjeta.metadata.imagen3 === '' ||
        this.tarjeta.metadata.imagen4 === ''
    },

    isAProductRoute () {
      return this.$route.name === 'products' || this.$route.name === 'product'
    },

    messageErrorFileExtension () {
      return this.$t('mFeedSectionContentCardEditionDesign5.validation.fileExtension')
    },

    messageErrorFileSize () {
      return this.$t('mFeedSectionContentCardEditionDesign5.validation.fileSize')
    },

    messageErrorFileRequired () {
      return this.$t('mFeedSectionContentCardEditionDesign5.validation.fileRequired')
    },

    messageErrorNombre () {
      return this.$validation.getValidationMessage('mFeedSectionContentCardEditionDesign5', this.$v.element.descripcion.nombre, 'nombre')
    },

    productoCategoriaNombre () {
      return this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.descripcion.categoria).nombre
    },

    productoPrecio () {
      return this.esPago
        ? this.$t('mFeedSectionContentCardEditionDesign5.infoPrice.buy')
        : this.$t('mFeedSectionContentCardEditionDesign5.infoPrice.free')
    }
  },

  watch: {
    showMetadataValidationError () {
      if (this.showMetadataValidationError) {
        this.isMetadataValid = Object.values(this.tarjeta.metadata).find(md => md === '') === undefined
      }
    },

    'tarjeta.metadata': {
      deep: true,

      handler () {
        this.getValidationError()
      }
    }
  },

  created () {
    if (this.element.tarjeta.tipo === 5 && this.element.tarjeta.metadata) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta.tipo,
        metadata: Object.assign({}, this.element.tarjeta.metadata) })
    }

    this.getValidationError()
  },

  mounted () {
    this.getReference()
  },

  methods: {
    changeCardType () {
      this.$emit('changeCardType', this.tarjeta.tipo)
    },

    changeCardImage (inputId) {
      document.getElementById(inputId).click()
    },

    changeElementNombre (event) {
      this.$v.element.descripcion.nombre.$touch()
      this.$emit('changeElementNombre', event.target.value)
      this.$emit('getValidationError', 'name', this.$v.element.descripcion.nombre.$error)
      this.getReference()
    },

    getReference () {
      this.$emit('getReference', 'nombre', this.$refs.nombre)
      this.$emit('getReference', 'imagen1', this.$refs.imagen1)
      this.$emit('getReference', 'imagen2', this.$refs.imagen2)
      this.$emit('getReference', 'imagen3', this.$refs.imagen3)
      this.$emit('getReference', 'imagen4', this.$refs.imagen4)
    },

    getValidationError () {
      this.isMetadataValid = Object.values(this.tarjeta.metadata).find(md => md === '') === undefined
      this.$emit('getValidationError', 'card', !this.isMetadataValid)
      this.getReference()
    },

    previewCardImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'image')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        var reader = new FileReader()
        reader.onload = (e) => {
          document.getElementById(input.getAttribute('data-img-id')).src = e.target.result
          let pos = input.getAttribute('data-img-pos')
          this.tarjeta.metadata[`imagen${pos}`] = e.target.result
          this.$emit('changeElementCard', this.tarjeta)
          this.getReference()
        }
        reader.readAsDataURL(input.files[0])
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeFeedSectionContentCardEditionModalFileExtensionError', { seccion: this.isAnAssetRoute ? 'assets' : 'products' })
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    }
  }
}
</script>
